<template>
  <section class="result-wrapper">
    <section v-if="applied">
      <div class="row">
      <div class="col-6 insurance-bg auto-bg desktop-only" />
      <div class="col-6 desktop-pl-0 col-xs-12 col-md-6">
        <ApplySuccess quotation="true" />
      </div>
    </div>
    </section>
    <section v-else>
    <div class="banner insurance auto short mobile-only">
      <div class="container">
        <h1>{{ t('insurance.auto_title') }}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-6 insurance-bg auto-bg desktop-only" />
      <div class="col-6 desktop-pl-0 col-xs-12 col-md-6">
    <div class="insurance-form">
      <div class="container profile-content">
        <h1 class="desktop-only">
{{ t('insurance.auto_title') }}
</h1>
        <h3>{{ t('insurance.auto_question') }}</h3>
        <form id="auto-form" @submit.prevent="formSubmit" :class="{loading: submitting}" autocomplete="off">
        <section v-show="step===1">
        <div class="form-group">
          <label>{{ t('insurance.auto_class') }}</label>
          <div :class="'column-'+types.length" class="radio-group full">
            <label v-for="item, index in types" :key="index" class="btn-radio">
              <input
                v-model="type"
                :value="item.code"
                :fieldTitle="t('insurance.auto_class', {}, 'zh')"
                :fieldValue="type"
                fieldname="type"
                field-single
                name="type"
                type="radio"
              >
              <span>{{ item.name }}</span>
            </label>
          </div>
        </div>
        <div class="form-group">
          <div :class="'column-'+authes.length" class="radio-group full">
            <label v-for="item, index in authes" :key="index" class="btn-radio">
              <input
                v-model="auth"
                :value="item.code"
                :fieldValue="auth"
                :fieldTitle="t('insurance.auto_parallel', {}, 'zh') + '/' + t('insurance.auto_authorized', {}, 'zh')"
                field-single
                fieldname="authorized"
                name="auth"
                type="radio"
              >
              {{ item.name }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <label class="inbox-label">{{ t('insurance.auto_depot') }}</label>
          <v-select
            id="brand-sel"
            :options="brandOptions"
            v-model="brand"
            :fieldValue="brand"
            :searchable="true"
            :fieldTitle="t('insurance.auto_depot', {}, 'zh')"
            v-on:input="brandChange()"
            fieldname="brand"
            required
            label="name"
          />
        </div>
        <div class="form-group">
          <label class="inbox-label">{{ t('insurance.auto_model') }}</label>
          <v-select
            id="model-sel"
            :options="modelOptions"
            v-model="model"
            :fieldValue="model"
            :searchable="true"
            :fieldTitle="t('insurance.auto_model', {}, 'zh')"
            fieldname="model"
            label="name"
            required
          />
        </div>
        <div class="form-group">
          <label class="inbox-label">{{ t('insurance.manufacture_year') }}</label>
          <v-select
            id="year-sel"
            :options="yearOptions"
            v-model="year"
            :reduce="(option) => option.code"
            :searchable="true"
            :fieldValue="year"
            :fieldTitle="t('insurance.manufacture_year', {}, 'zh')"
            fieldname="manufacture_year"
            label="name"
            required
          />
        </div>
        </section>
        <section v-show="step===2">
        <div class="form-group">
          <label>{{ t('insurance.auto_owner') }}</label>
          <div :class="'column-'+ownerOptions.length" class="radio-group full">
          <label v-for="item, index in ownerOptions" :key="index" class="btn-radio">
              <input
                v-model="owner"
                :value="item.code"
                :fieldTitle="t('insurance.auto_owner', {}, 'zh')"
                :fieldValue="owner"
                name="owner"
                type="radio"
                field-single
                fieldname="owner"
              >
              {{ item.name }}
            </label>
          </div>
        </div>
        <div class="form-group">
        <label>{{ t('insurance.auto_info') }}</label>
      </div>
        <div class="form-group">
          <label class="inbox-label">{{ t('insurance.auto_price') }}</label>
          <MoneyInput :value="price" :fieldTitle="t('insurance.auto_price', {}, 'zh')" fieldname="price" fieldType="text" required />
        </div>
        <div class="form-group">
          <label class="inbox-label">{{ t('insurance.auto_ncb') }}</label>
          <input
            :fieldTitle="t('insurance.auto_ncb', {}, 'zh')"
            class="form-control"
            type="text"
            fieldname="NCB"
            fieldType="text"
            required
>
        </div>
        <div class="form-group">
          <label>{{ t('insurance.auto_scope') }}</label>
          <div :class="'column-'+scopeOptions.length" class="radio-group full">
          <label v-for="item, index in scopeOptions" :key="index" class="btn-radio">
              <input
                v-model="scope"
                :value="item.code"
                :fieldTitle="t('insurance.auto_scope', {}, 'zh')"
                :fieldValue="scope"
                field-single
                fieldname="scope"
                name="scope"
                type="radio"
              >
              {{ item.name }}
            </label>
          </div>
        </div>
      </section>
      <section v-show="step===3">
        <div class="form-group">
          <label>{{ t('insurance.auto_drive_count') }}</label>
          <div :class="'column-'+driveOptions.length" class="radio-group full">
          <label v-for="item, index in driveOptions" :key="index" class="btn-radio">
              <input
                v-model="driverCount"
                :value="item.code"
                :fieldTitle="t('insurance.auto_drive_count', {}, 'zh')"
                :fieldValue="item.name"
                field-single
                fieldname="driver_count"
                name="drive"
                type="radio"
              >
              {{ item.name }}
            </label>
          </div>
        </div>
          <DriverForm id="1" title="" />
          <DriverForm id="2" v-show="driverCount>1" :title="t('insurance.auto_driver')+'2'" />
          <DriverForm id="3" v-show="driverCount>2" :title="t('insurance.auto_driver')+'3'" />
          <DriverForm id="4" v-show="driverCount>3" :title="t('insurance.auto_driver')+'4'" />
        <div class="form-group">
          <label>{{ t('insurance.auto_suspension') }}</label>
          <div :class="'column-'+boolOptions.length" class="radio-group full">
          <label v-for="item, index in boolOptions" :key="index" class="btn-radio">
              <input
                v-model="suspension"
                :value="item.code"
                :fieldTitle="t('insurance.auto_suspension',{},'zh')"
                :fieldValue="suspension"
                field-single
                fieldname="suspension"
                name="suspension"
                type="radio"
              >
              {{ item.name }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <label>{{ t('insurance.auto_deducted') }}</label>
          <div :class="'column-'+boolOptions.length" class="radio-group full">
          <label v-for="item, index in boolOptions" :key="index" class="btn-radio">
              <input
                v-model="deducted"
                :value="item.code"
                :fieldTitle="t('insurance.auto_deducted',{},'zh')"
                :fieldValue="deducted"
                field-single
                fieldname="deducted"
                name="deducted"
                type="radio"
              >
              {{ item.name }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <label class="inbox-label">{{ t('insurance.auto_applicant') }}</label>
          <input
            :fieldTitle="t('insurance.auto_applicant',{},'zh')"
            class="form-control"
            type="text"
            fieldname="applicant"
            required
            >
        </div>
        <div class="form-group">
          <label class="inbox-label">{{ t('insurance.email') }}</label>
          <input
            :fieldTitle="t('insurance.email',{},'zh')"
            class="form-control"
            type="email"
            fieldname="email_address"
            fieldType="email"
            required
            >
        </div>
        <div class="form-group">
          <label class="inbox-label">{{ t('insurance.mobile') }}</label>
          <input
            :fieldTitle="t('insurance.mobile',{},'zh')"
            class="form-control"
            type="tel"
            minlength="8"
            maxlength="8"
            fieldname="mobile"
            fieldType="mobile"
            required
            >
        </div>
        </section>
        <div class="disclaimer">
          <b>{{ t('insurance.disclaimer') }}</b>
          <div v-html="t('insurance.disclaimer_desc')" />
        </div>
        <div class="text-center">
          <a @click="submitHandle" class="btn btn-secondary btn-md">
{{ step===maxStep ? t('loan.apply') : t('common.next_page') }}
          </a>
        </div>
      </form>
      </div>
    </div>
      </div>
    </div>
  </section>
</section>
</template>
<script>
import commonFunc from '~/assets/js/commonHelper.js'
import MoneyInput from "~/components/form/MoneyInput.vue";
import DriverForm from "~/components/form/DriverForm.vue";
import ApplySuccess from "~/components/form/ApplySuccess.vue";
export default {
  components: {
    MoneyInput,
    ApplySuccess,
    DriverForm
  },
  data: function () {
    return {
      applied: false,
      step: 1,
      maxStep: 3,
      submitting: false,
      type: this.t('insurance.auto_third_party', {}, 'zh'),
      price: 0,
      boolOptions: [
        { name: this.t('common.yes'), code: '是' },
        { name: this.t('common.no'), code: '否' },
      ],
      suspension: '否',
      deducted: '否',
      types: [
        { name: this.t('insurance.auto_third_party'), code: this.t('insurance.auto_third_party', {}, 'zh') },
        { name: this.t('insurance.auto_full'), code: this.t('insurance.auto_full', {}, 'zh') },
      ],
      ownerOptions: [
        { name: this.t('insurance.auto_personal'), code: this.t('insurance.auto_personal', {}, 'zh') },
        { name: this.t('insurance.auto_company'), code: this.t('insurance.auto_company', {}, 'zh') },
      ],
      owner: this.t('insurance.auto_personal', {}, 'zh'),
      brandOptions: [],
      brand: '',
      category: this.t('insurance.auto_sedan'),
      target: '',
      authes: [
        { name: this.t('insurance.auto_parallel'), code: this.t('insurance.auto_parallel', {}, 'zh') },
        { name: this.t('insurance.auto_authorized'), code: this.t('insurance.auto_authorized', {}, 'zh') },
      ],
      auth: this.t('insurance.auto_parallel', {}, 'zh'),
      modelOptions: [],
      model: '',
      yearOptions: [],
      year: '',
      scopeOptions: [
        { name: this.t('insurance.auto_scope1'), code: this.t('insurance.auto_scope1', {}, 'zh') },
        { name: this.t('insurance.auto_scope2'), code: this.t('insurance.auto_scope2', {}, 'zh') },
      ],
      scope: this.t('insurance.auto_scope1'),
      driveOptions: [
        { name: '1', code: 1 },
        { name: '2', code: 2 },
        { name: '3', code: 3 },
        { name: '4', code: 4 },
      ],
      driverCount: 1,
    };
  },
  layout(context) {
    return "default";
  },
  head() {
    return {
      ...commonFunc.getSeoMeta(this.$store.state.layout.seo),
      bodyAttrs: {
        class: 'insurance-page'
      }
    }
  },
  async asyncData({ route, store }) {
    const applied = route.query.applied
    await store.dispatch("option/fetchCarFactory");
    const factories = JSON.parse(JSON.stringify(store.state.option.carFactories))
    await store.dispatch("layout/fetchSeo", {
      path: route.path
    });
    return { applied: applied, brandOptions: factories }
  },
  mounted() {
    const currentYear = new Date().getFullYear();
    const years = [];
    let startYear = 1949;
    while (startYear < currentYear) {
      startYear++;
      years.push({ name: startYear, code: startYear });
    }
    this.yearOptions = years.reverse();
  },
  methods: {
    brandChange: async function() {
      this.model = ''
      const params = { carFactory: this.brand }
      await this.$store.dispatch('option/fetchCarModel', params)
      this.modelOptions = JSON.parse(JSON.stringify(this.$store.state.option.carModels))
    },
    goToTop: function() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".insurance-form").offset().top - 70
      }, 100);
    },
    submitHandle: function(e) {
      let valid = true
      const vm = this
      if (this.step === 1) {
        if (this.brand === '') {
          $("#brand-sel").find('input').focus()
          valid = false
          return false
        }
        if (this.model === '') {
          $("#model-sel").find('input').focus()
          valid = false
          return false
        }
        if (this.year === '') {
          $("#year-sel").find('input').focus()
          valid = false
          return false
        }
      }
      $("#auto-form").find('input').filter('[required]:visible').each(function(i, n) {
        if ($(this).val() === '') {
          $(this).focus();
          valid = false
          return false
        }
        if ($(this).attr('type') === 'email' && !commonFunc.isValidEmail($(this).val())) {
          $(this).focus();
          commonFunc.toast(vm.t('common.invalid_email'), 'warning')
          valid = false
          return false
        }
      })
      if (!valid || this.submitting) {
        return
      }
      this.goToTop();
      if (this.step >= this.maxStep) {
        this.submitting = true;
        commonFunc.formSubmit('auto-form', process.env.FORM_AUTO_ID, function() {
          window.location.href = '/insurance/auto?applied=1'
        }, function(error) {
          commonFunc.toast(error, 'danger')
          vm.submitting = false;
        })
        return
      }
      this.step += 1;
    }
  },
};
</script>